export default "__VITE_ASSET__B2n6RlQE__"